<template>
  <div class="tc-select-modal">
    <div class="tc-select-modal-content">
      <component
        :is="view"
        :controller="controller"
        @change-model="changeModel"
        @back-to-model-list="backToModelList"
      />
    </div>
  </div>
</template>

<script>
import ModelList from "./model-list/model-list";
import ModeSelect from "./mode-select/mode-select";
import ModelSettings from "./model-settings/model-settings";
import { getModelChildrenIds } from "@/utils";

export default {
  props: ["map", "controller"],
  components: {
    ModelList,
    ModeSelect,
    ModelSettings
  },
  computed: {
    view() {
      return this.$store.state.trafficCount.view;
    }
  },
  methods: {
    async changeModel({ id, children, name }) {
      const ids = getModelChildrenIds(children);
      this.$store.commit("SET_TC_MODEL", { ids, id, name, children });
      this.$store.commit("SET_TC_STATE_PROP", {
        name: "view",
        value: "mode-select"
      });
      await this.controller.toggleOn(ids);
      await this.controller.setTransportSystems(ids);
      await this.controller.setProfiles(ids);
      await this.controller.flyToModel(id);
    },
    backToModelList() {
      const ids = this.$store.state.trafficCount.model.ids;
      this.controller.toggleOff(ids);
      this.$store.commit("SET_TC_STATE_PROP", {
        name: "view",
        value: "model-list"
      });
      this.$store.commit("CLEAR_TC_MODEL");
      this.$store.commit("CLEAR_TC_FILL");
    }
  }
};
</script>

<style lang="scss">
.tc-select-modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;

  &-content {
    position: absolute;
    top: 15vh;
    left: 50%;
    transform: translate(-50%);
    border: 1px solid transparent;
    border-radius: var(--border-radius);
    background-color: var(--modal_bg) !important;
    border-color: var(--dividers_low_contrast) !important;
    color: var(--text_secondary) !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 16px;
    height: auto;
    min-width: 320px;
    width: max-content;
  }
}
.light-theme {
  .tc-select-modal-content {
    border: none !important;
  }
}
</style>
